import { dimensions, SvgIconProps } from "./SvgIcon";

export const SelectIcon = (props: SvgIconProps) => {
  const { width, height } = dimensions(props);
  return (
    <svg
      style={{ display: "block", ...props.style }}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7711_44339)">
        <path
          d="M3 9H2V2H9V3C9 3.26522 9.10536 3.51957 9.29289 3.70711C9.48043 3.89464 9.73478 4 10 4C10.2652 4 10.5196 3.89464 10.7071 3.70711C10.8946 3.51957 11 3.26522 11 3V2C11 1.46957 10.7893 0.960859 10.4142 0.585786C10.0391 0.210714 9.53043 0 9 0L2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 9C0 9.53043 0.210714 10.0391 0.585786 10.4142C0.960859 10.7893 1.46957 11 2 11H3C3.26522 11 3.51957 10.8946 3.70711 10.7071C3.89464 10.5196 4 10.2652 4 10C4 9.73478 3.89464 9.48043 3.70711 9.29289C3.51957 9.10536 3.26522 9 3 9Z"
          fill="currentColor"
        />
        <path
          d="M9.06107 7.64523L9.85407 6.85323C9.91673 6.79062 9.96164 6.7125 9.98419 6.62684C10.0067 6.54118 10.0061 6.45107 9.98244 6.36572C9.95874 6.28038 9.91279 6.20286 9.8493 6.1411C9.7858 6.07934 9.70704 6.03556 9.62107 6.01423L5.62107 5.01423C5.53728 4.99397 5.44972 4.99537 5.36662 5.01828C5.28352 5.0412 5.20763 5.08489 5.14607 5.14523C5.08508 5.20635 5.04095 5.28223 5.01799 5.36547C4.99504 5.44871 4.99403 5.53648 5.01507 5.62023L6.01507 9.62023C6.03665 9.70601 6.08061 9.78452 6.14245 9.84777C6.20429 9.91101 6.2818 9.95672 6.36707 9.98023C6.41026 9.9929 6.45505 9.9993 6.50007 9.99923C6.63264 9.99881 6.75975 9.94639 6.85407 9.85323L7.64607 9.06023L10.2931 11.7062C10.4817 11.8884 10.7343 11.9892 10.9965 11.9869C11.2587 11.9846 11.5095 11.8795 11.6949 11.694C11.8803 11.5086 11.9855 11.2578 11.9877 10.9956C11.99 10.7334 11.8892 10.4808 11.7071 10.2922L9.06107 7.64523Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_7711_44339">
          <rect width="12" height="12" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
};
